import React, { useState } from "react";

import * as classes from "./charts.module.scss";
import { useTranslation } from 'react-i18next';

const Charts = ({ ChartData }) => {
  const [data, setData] = useState({ ...ChartData });
  const {t} = useTranslation();
  return (
    <div className="flex flex-col md:flex-row">
      <div className="w-full md:w-1/2 my-10">
        <div className="  text-center md:text-left md:w-full text-3xl md:text-4xl mx-auto">
          <span className="font-extrabold">{t(data[0])}</span>{" "}
          <br className="md:hidden" />
          {t(data[1])}
        </div>
        <div className="flex flex-col md:hidden w-full md:w-1/2 my-20 md:my-0">
          <img alt="logos" src="https://d2lxkizvrhu4im.cloudfront.net/images/partnership.png" />
        </div>
        <div className="my-5">
          <div className="font-bold my-3 text-lg">{t('context')}</div>
          <div className="text-gray-500 text-base">{t(data.contexte)}</div>
        </div>

        <div className="flex flex-col my-5">
          <div className="font-bold my-3 text-lg">{t('results')}</div>
          <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-3">
            {
              data.Résultats.map((i, index) => {
                return (
                  <div className="flex flex-row md:flex-col text-start space-x-6 md:space-x-0 md:w-1/3">
                    <div className="text-4xl font-bold w-2/5 md:w-auto ">{t(i.heading)}</div>
                    <div className="text-gray-500 text-sm  w-3/5 md:w-auto ">{t(i.desc)}</div>
                  </div>
                );
              })
            }
          </div>
        </div>

        <div className="my-10">
          <div className="font-bold my-3 text-lg">{t('strong_points')}</div>
          <div className="flex flex-row justify-between flex-wrap">
            {
              data.points.map((i, index) => {
                return (
                  <div className="flex flex-row space-x-1 items-center font-bold w-1/2 md:w-auto">
                    <img
                      alt="logos"
                      src="https://d2lxkizvrhu4im.cloudfront.net/icons/tick_icon.svg"
                      className="m-0"
                    />{" "}
                    <span>{t(data.points[index])}</span>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
      <div className="flex flex-col hidden md:flex w-full md:w-1/2 my-20 md:my-0">
        <img
          alt="logos"
          src="https://d2lxkizvrhu4im.cloudfront.net/images/partnership.png"
        />
      </div>
    </div>
  );
};

export default Charts;
